import { lazy } from 'react';
const SheetOutputSummary = lazy(() => import('./SheetOutputTabs'));

const SheetOutputSummaryRoutes = [
  {
    path: '/sheet-output-summary',
    component: SheetOutputSummary
  }
];

export default SheetOutputSummaryRoutes;
